import { i as u, s as f, x as g } from "../../lit-element-6iugfgmM.js";
import { e as b } from "../../custom-element-wk-AooBb.js";
import { n as c } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
const y = u`:host{--card-background-color: var(--spectrum-gray-75);--card-border-radius: 16px;--card-font-color: var(--spectrum-gray-800);--card-font-size: 32px;--card-font-weight: 400;background-color:var(--card-background-color)}a{align-items:center;border:1px solid var(--spectrum-gray-300);border-radius:var(--card-border-radius);color:var(--card-font-color);display:flex;font-size:var(--card-font-size);font-weight:var(--card-font-weight);justify-content:center;height:inherit;text-decoration:none;width:inherit}a:hover{border:1px solid var(--spectrum-gray-700);cursor:pointer}`;
var v = Object.defineProperty, m = Object.getOwnPropertyDescriptor, s = (h, t, a, o) => {
  for (var i, r = o > 1 ? void 0 : o ? m(t, a) : t, n = h.length - 1; n >= 0; n--) (i = h[n]) && (r = (o ? i(t, a, r) : i(r)) || r);
  return o && r && v(t, a, r), r;
};
const p = "af-link-card-click", d = class d extends CustomEvent {
  constructor(t) {
    super(p, { detail: t, bubbles: !0, composed: !0 });
  }
};
d.EVENT_NAME = p;
let l = d, e = class extends f {
  constructor() {
    super(...arguments), this.label = "", this.href = "", this.slug = "";
  }
  static get styles() {
    return y;
  }
  handleLinkAnalytics() {
    this.dispatchEvent(new l({ href: this.href, slug: this.slug }));
  }
  render() {
    if (this.href) return g`<a href="${this.href}" aria-label="${this.label}" @click="${this.handleLinkAnalytics}"><slot></slot></a>`;
  }
};
s([c({ type: String })], e.prototype, "label", 2), s([c({ type: String })], e.prototype, "href", 2), s([c({ type: String })], e.prototype, "slug", 2), e = s([b("af-link-card")], e);
const A = e;
export {
  p as EVENT_NAME,
  l as LinkCardEvent,
  A as default
};
//# sourceMappingURL=LinkCard.js.map
